import React from 'react';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {createStackNavigator, StackHeaderProps} from '@react-navigation/stack';

import BrandHeader from '../components/BrandHeader';
import {AppRoute} from '../models/AppRoute';
import {
  HeaderConfig,
  RootKitchenSinkParamList,
} from '../models/navigationTypes';
import KitchenSinkCardScreen from '../screens/kitchensink/KitchenSinkCardScreen';
import KitchenSinkScreen from '../screens/kitchensink/KitchenSinkScreen';

import useCommonScreenOptions from './hooks/useCommonScreenOptions';

export const header =
  (config: HeaderConfig) =>
  ({navigation, route}: StackHeaderProps) =>
    (
      <BrandHeader
        navigation={navigation as any}
        route={route}
        config={config}
      />
    );

const Stack = createStackNavigator<RootKitchenSinkParamList>();

const RootKitchenSinkStackNavigator = () => {
  const commonScreenOptions = useCommonScreenOptions(true);

  return (
    <GestureHandlerRootView
      style={{flex: 1}}
      testID="gesture-handler-root-view">
      <Stack.Navigator screenOptions={commonScreenOptions}>
        <Stack.Screen
          name={AppRoute.KITCHENSINK_INDEX}
          component={KitchenSinkScreen}
          options={{
            header: header({
              back: false,
              shop: false,
              filter: false,
              burger: false,
              search: false,
              blinkerMode: true,
            }),
          }}
        />
        <Stack.Screen
          name={AppRoute.KITCHENSINK_CARDS}
          component={KitchenSinkCardScreen}
          options={{
            header: header({
              back: false,
              shop: false,
              filter: false,
              burger: false,
              search: false,
              blinkerMode: true,
            }),
          }}
        />
      </Stack.Navigator>
    </GestureHandlerRootView>
  );
};

export default RootKitchenSinkStackNavigator;
